import { TriangleAlert } from 'lucide-react';

interface WarningSectionProps {
  title: string;
  description: string;
  variant?: 'desktop' | 'mobile';
}

const WarningSection = ({
  title,
  description,
  variant = 'desktop',
}: WarningSectionProps) => {
  const isDesktop = variant === 'desktop';

  return (
    <div
      className={`flex w-full gap-3 rounded-lg bg-warning-bg ${
        isDesktop ? 'p-4 px-5' : 'p-3 px-3.5'
      }`}
    >
      <TriangleAlert
        className={`shrink-0 text-warning-icon ${
          isDesktop ? 'h-5 w-5' : 'h-4 w-4'
        }`}
      />
      <div className="flex flex-col gap-1">
        <span
          className={`font-body font-semibold text-warning-text ${
            isDesktop ? 'text-sm' : 'text-[13px]'
          }`}
        >
          {title}
        </span>
        <p
          className={`font-body leading-[1.4] text-warning-text ${
            isDesktop ? 'text-[13px]' : 'text-xs'
          }`}
        >
          {description}
        </p>
      </div>
    </div>
  );
};

export default WarningSection;
